import { IHelpItemDescription, ISingleImageData } from '@ConfigLoader/ConfigFiles';
import ConfigLoader from '@ConfigLoader/ConfigLoader';
import React from 'react';

export function textParser(
    textData: IHelpItemDescription,
    imageData: { single?: ISingleImageData; array?: Array<ISingleImageData> },
    contentByKey: { [key: string]: string },
    valuePlaceholders: { [key: string]: string }
) {
    let text = '';

    if (textData.text) text = textData.text;
    if (textData.textByKey && contentByKey[textData.textByKey]) text = contentByKey[textData.textByKey];

    for (var key in valuePlaceholders) {
        text = text.replace(key, valuePlaceholders[key]);
    }

    //

    //var images = text.match(/<%([\s\S]*?)%>/gm);

    /*
        if (images && images.length > 0) {
            for (var i = 0; i < images.length; i++) {
                const imgItem = images[i];
                const imageName = imgItem.match(/(?<=img=')(.+)(?=')/gm);

                if (imageData.single) {
                    text = text.replace(images[i], getImagePathResolver(imageData.single, true));
                }

                if (imageData.array) {
                    for (var e = 0; e < imageData.array.length; e++) {
                        if (imageName && imageName[0] === imageData.array[e].img) {
                            text = text.replaceAll(images[i], getImagePathResolver(imageData.array[e], true));
                        }
                    }
                }
            }
        }
            */
    return <p dangerouslySetInnerHTML={{ __html: text }}>{}</p>;
}
